module.exports = __webpack_public_path__ + "media/promo/lum2021/images/2nd-49a632ac0e91e92ce5cf9cbc5895e797.png";